export interface CustomToasterProps {
    toasterAlignmentHorizontal?: "start" | "center" | "end";
    toasterAlignmentVertical?: "top" | "bottom";
    toasterPosition?: "fixed" | "absolute",
}

export interface Toaster {
    id: number;
    array: ToasterAlert[];
    text: string | React.ReactNode;
    type: "error" | "warning" | "success" | "informational",
    size: "small" | "medium" | "large" | "xlarge";
    titleLevel: 1 | 2 | 3 | 4 | 5 | 6;
    width: string | number,
    title: string,
  }

export interface ToasterAlert {
    id: string;
    timeout?: number;
  }

  export enum ToasterAlignmentHorizontal {
    START = "start",
    CENTER = "center",
    END = "end",
  }
  
  export enum ToasterAlignmentVertical {
    TOP = "top",
    BOTTOM = "bottom",
  }
  
  export enum ToasterPosition {
    FIXED = "fixed",
    ABSOLUTE = "absolute",
  }